
import { DownloadS3BlobComponent } from './download-s3-blob/download-s3-blob.component';

const DownloadModule =
  angular.module('topbroker.sharedDownload', [])
    .component('downloadS3Blob', DownloadS3BlobComponent)
    .name;

export default DownloadModule;
